// extracted by mini-css-extract-plugin
export default {"contactform":"ContactForm_contactform__ru3IZ","content":"ContactForm_content__gkeM9","err-mes":"ContactForm_err-mes__oXc7u"};